module.exports = __webpack_public_path__ + "static/media/icon-clients-blue.76a20111.svg";